import styled from 'styled-components';

export const CartItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px;
  margin-top: 40%;
`;

export const ModalBody = styled.div`
  padding: 10px;
  line-height: 24px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;

  > span {
    font-size: 1.5rem;
    font-weight: 500;
    margin-left: 10px;
  }
`;

export const Footer = styled.div``;

export const OrderPaymentContainer = styled.div``;

export const CreditCardContainer = styled.div<{
  isSelected: boolean;
}>`
  padding: 10px 15px;
  border-radius: 5px;
  border: 2px solid rgba(32, 154, 214, 1);
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  box-shadow: ${({ isSelected }) =>
    isSelected ? '0px 4px 12px rgba(0, 0, 0, 0.08)' : 'none'};
  border: ${({ isSelected }) => {
    if (!isSelected) {
      return '1px solid rgba(0, 0, 0, 0.23)';
    }
    return '2px solid rgba(32, 154, 214, 1)';
  }};
  cursor: pointer;
`;

export const CreditCardErrorMessage = styled.div`
  font-weight: 400;
  color: rgba(212, 63, 88, 1);
  size: 0.9rem;
  margin-left: 30px;
`;

export const Expiry = styled.div`
  min-width: 20%;
  max-width: 20%;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.63);
  size: 0.9rem;
  margin-left: 20px;
`;

export const AddPaymentMethod = styled.a`
  font-weight: 400;
  color: rgba(32, 154, 214, 1);
  font-size: 0.8rem;
`;

export const DefaultCard = styled.span`
  font-weight: 400;
  background: #cbf5d8;
  color: rgba(0, 150, 78, 1);
  font-size: 0.9rem;
  padding: 2px 6px;
  border-radius: 24px;
  border: 1px solid green;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  margin-top: 10px;
  gap: 12px;
`;

export const ButtonLabel = styled.div`
  margin-left: 5px;
`;

export const AddButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0;
  margin-top: 10px;
`;

export const CardHolderName = styled.div`
  min-width: 150px;
  max-width: 150px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.93);
  size: 0.9rem;
  overflow-wrap: break-word;
  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }
`;

export const LastDigits = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.93);
  size: 0.9rem;
  margin-left: 10px;
`;

export const CloseButton = styled.div`
  cursor: pointer;
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.93);
  margin: 10px 0px;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SubText = styled.div`
  font-size: 0.8rem;
  color: #555;
  margin-bottom: 12px;
`;

export const CardDetailsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const CardRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ExpiryWrapper = styled.div`
  margin-left: auto; /* Push expiry details to the right */
  color: gray;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const PayByInvoiceContainer = styled.div<{
  isSelected: boolean;
}>`
  padding: 10px 15px;
  border-radius: 5px;
  border: 2px solid rgba(32, 154, 214, 1);
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: ${({ isSelected }) =>
    isSelected ? '0px 4px 12px rgba(0, 0, 0, 0.08)' : 'none'};
  border: ${({ isSelected }) =>
    isSelected
      ? '2px solid rgba(32, 154, 214, 1)'
      : '1px solid rgba(0, 0, 0, 0.23)'};
  cursor: pointer;
`;

export const PayByInvoiceTitle = styled(CardHolderName)``;
